export default __webpack_public_path__ + "static/media/medicenter-dear-patient-icon2.6500c311.PNG";